import React from "react";
import { motion } from "framer-motion";
import { projekte } from "../../helper/data";

const EngagementHarmonie = () => {
  const engagementHarmonieProject = projekte.find(
    (project) => project.titel === "Engagement"
  );

  if (!engagementHarmonieProject) {
    return <p>Projekt nicht gefunden.</p>;
  }

  return (
    <div className="container my-4 text-center">
      <motion.div
        className="announcement bg-light p-4 p-md-5 rounded shadow text-start responsive-fs"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <img
          src={engagementHarmonieProject.images[0]}
          alt="Demokratie"
          className="img-fluid rounded mb-3"
        />
        <h3 className="fw-semibold text-success mt-4">
          {engagementHarmonieProject.desc.toUpperCase()}
        </h3>

        <div>
          <strong>Bezeichnung der Maßnahme/ des Vorhabens:</strong>{" "}
          {engagementHarmonieProject.titel2}
        </div>

        <div>
          <strong>Projektzeitraum:</strong> 01.09.2025 – 31.12.2025
        </div>

        <div className="mt-3">
          <p className="justify-text">{engagementHarmonieProject.desc2}</p>
          <p className="justify-text">{engagementHarmonieProject.desc3}</p>
          <p className="justify-text">{engagementHarmonieProject.desc4}</p>
          <p>
            <ul>
              <ol>- {engagementHarmonieProject.desc41}</ol>
              <ol>- {engagementHarmonieProject.desc42}</ol>
              <ol>- {engagementHarmonieProject.desc43}</ol>
              <ol>- {engagementHarmonieProject.desc44}</ol>
            </ul>
          </p>
          <p className="justify-text">{engagementHarmonieProject.desc5}</p>
          <p className="justify-text">{engagementHarmonieProject.desc6}</p>
          <p className="justify-text">{engagementHarmonieProject.desc7}</p>
        </div>
        <div className="mt-5">
          <a
            href="https://www.engagiert-in-nrw.de/foerderprogramm-2000-x-1000-euro-fuer-das-engagement"
            target="_blank"
            rel="noopener noreferrer"
          >
            Förderprogramm »2.000 x 1.000 Euro für das Engagement« | Engagiert
            NRW
          </a>
        </div>
        <div>
          <p className="card-text mt-3">
            Melde dich an und werde Teil dieses wichtigen Projekts unter:{" "}
            <a href="mailto:info@harmonieneuss.de">info@harmonieneuss.de</a>
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default EngagementHarmonie;
